import QuantityInput from "./quantity-input.ts";

export enum ArticleFormType {
  Existing = "article-form",
  New = "new-article-form",
}

export default class ArticleForm extends EventTarget {
  static ChangeEventType = "change";

  static Selector(type: ArticleFormType) {
    return `[data-type="${type}"]`;
  }

  #element: HTMLElement;

  #type: ArticleFormType;

  #index = -1;

  #articleId = "";

  #quantity = 0;

  #articleIdInput: HTMLInputElement;

  #quantityInput: QuantityInput;

  constructor(element: HTMLElement, type: ArticleFormType, index = -1) {
    super();
    const articleIdInput = element.querySelector(
      '[data-type="article-id-input"]',
    );
    const quantityInput = element.querySelector(QuantityInput.Selector);

    this.#element = element;
    this.type = type;
    this.index = index;

    if (
      articleIdInput instanceof HTMLInputElement &&
      quantityInput instanceof HTMLElement
    ) {
      this.#articleId = articleIdInput.value.trim();
      this.#articleIdInput = articleIdInput;
      this.#articleIdInput.addEventListener("change", this.#onArticleIdChange);
      this.#articleIdInput.addEventListener("input", this.#onArticleIdInput);

      this.#quantityInput = new QuantityInput(quantityInput);
      this.#quantity = this.#quantityInput.value;
      this.#quantityInput.addEventListener(
        QuantityInput.ChangeEventType,
        this.#onQuantityInputChange,
      );
    }
  }

  clone() {
    const clone = this.element.cloneNode(true) as HTMLElement;
    const articleForm = new ArticleForm(clone, this.type);

    return articleForm;
  }

  get element() {
    return this.#element;
  }

  get type() {
    return this.#type;
  }

  set type(type: ArticleFormType) {
    this.#type = type;
    this.#element.setAttribute("data-type", type);
  }

  get index() {
    return this.#index;
  }

  set index(value: number) {
    this.#index = value;
  }

  get articleId() {
    return this.#articleId;
  }

  set articleId(value: string) {
    this.#articleId = value;
    this.#articleIdInput.value = value;
  }

  get quantity() {
    return this.#quantity;
  }

  #onArticleIdChange = (e: Event) => {
    e.stopPropagation();
  };

  #onArticleIdInput = () => {
    this.#articleIdInput.removeAttribute("data-has-error");

    this.#articleId = this.#articleIdInput.value.trim();

    this.dispatchEvent(new Event(ArticleForm.ChangeEventType));
  };

  #onQuantityInputChange = () => {
    this.#quantity = this.#quantityInput.value;
  };
}
